var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{ref:"qrcodeIframe",attrs:{"id":"qrcodeIframe","scrolling":"no","width":"265","height":"265","frameBorder":"0","allowTransparency":"true","src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }